import { render, staticRenderFns } from "./DocumentTypeTable.vue?vue&type=template&id=2e09d722"
import script from "./DocumentTypeTable.vue?vue&type=script&lang=js"
export * from "./DocumentTypeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports